module.exports = __webpack_public_path__ + "img/hero-closed-shape-mobile.990ddd07.svg";